// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CredentialLoginHealthStatusSchema } from '../inputTypeSchemas/CredentialLoginHealthStatusSchema'

/////////////////////////////////////////
// CREDENTIAL LOGIN HEALTH SCHEMA
/////////////////////////////////////////

export const CredentialLoginHealthSchema = z.object({
  status: CredentialLoginHealthStatusSchema,
  reason: z.string().nullable(),
  field: z.string().nullable(),
  declared: z.string().nullable(),
  observed: z.string().nullable(),
  evidenceSource: z.string().nullable(),
  observedAt: z.coerce.date(),
})

export type CredentialLoginHealth = z.infer<typeof CredentialLoginHealthSchema>

export default CredentialLoginHealthSchema;
